import * as React from "react";
import { QueryParamProvider } from "use-query-params";
import { ReactRouter6Adapter } from "use-query-params/adapters/react-router-6";
const queryParamOptions = {
  enableBatching: true
};
const DefaultQueryParamProvider = ({ children }) => /* @__PURE__ */ React.createElement(QueryParamProvider, { adapter: ReactRouter6Adapter, options: queryParamOptions }, children);
export default DefaultQueryParamProvider;
